module.exports = __webpack_public_path__ + "static/media/foooter_code.57f3ffc6.png";